<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      ref="grid"
      :selectionEnabled="false"
    ></dx-grid>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data: () => ({
    url: "",
    title: "ManageEngine Categories",
    columns: [
      {
        label: "Id",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },


      {
        label: "Deleted",
        field: "deleted",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  methods: {
    async beforeSetupGrid() {
      this.url = "ManageengineCategories";
    },
  },
};
</script>
